// extracted by mini-css-extract-plugin
module.exports = {"btnForm":"Button_btnForm__32vDQ"};